<template>
  <div class="checkout-form-container checkout-form">
    <span class="cart-card-title mb-2">Delivery Address</span>
    <section class="my-body-section">
      <delivery-form ref="deliveryAddress"> </delivery-form>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DeliveryForm from '../../flow/steps/helpers/delivery-form.vue'
import Step from '../../flow/steps/mixin'

export default {
  mixins: [Step],
  data () {
    return {
      customer: {}
    }
  },
  components: {
    DeliveryForm
  },
  computed: {
    ...mapState('quote', ['quote'])
  },
  mounted () {
    if (this.quote) {
      this.updates = this.quote.customer
    } else if (this.lead) {
      const { firstName, lastName, email, phone } = this.lead
      //this.customer = {}
      this.updates = {
        ...this.updates,
        firstName,
        lastName,
        email,
        phone
      }
    }
  },
  methods: {   
    async save() {
      await this.saveDeliveryInfo()
      await this.updateCustomerInfo()      
    },
    saveDeliveryInfo() {

      return this.$store.dispatch('quote/quote.save', {
        eventName: 'delivery_address.add',
        input: {
          deliveryAddress: this.$refs.deliveryAddress.deliveryAddress
        }
      })
    },
    updateCustomerInfo() {
      let companyName = this.$refs.deliveryAddress ? this.$refs.deliveryAddress.customer.companyName : ''
      return this.$store.dispatch('quote/quote.save', {
        eventName: 'customer.update',
        input: {
          customer: {
            ...this.quote.customer,           
            companyName: companyName || ''
          }
        }
      })
    }
  }
}
</script>

<style>
  @import '../../flow/styles/checkout-form.scss';
</style>
<style scoped lang="scss">
  .check-info {
    display: flex;
    align-items: center;

    .check-item {
      margin-right: 12px;
    }

    span {
      color: #767676;
      font-size: 0.875rem;
      font-weight: 600;
    }
  }
  
  .cart-card-title {
    font-size: 24px;
    font-weight: 400;
    line-height: 28.8px;
    letter-spacing: -0.04em;
    color: #334155;
  }

</style>